import { Injectable } from '@angular/core';
import { MessageConstants } from '@app/core/constants/message.constants';
import { DxcToastService } from '@dxc/ui-components/toast';

@Injectable({ providedIn: 'root' })
export class ToastService {
  constructor(private dxcToastService: DxcToastService) {}

  notifyError(error: { message: string; code: string }) {
    const message = error?.message?.split(':')?.[1] ?? null;

    if (!message) return;

    this.dxcToastService.open({
      type: 'danger',
      title: MessageConstants.failed,
      body: message,
      duration: 3000
    });
  }
}
